import React from 'react';
import { motion } from 'framer-motion';
const BONUSES = [{
  title: 'Pack de 100 Prompts para Inteligencia Artificial',
  desc: 'Prompts listos para usar en: ChatGPT, Gemini, Midjourney, generadores de contenido',
  value: '$9.900 ARS'
}, {
  title: '25 Ideas de Negocios con Inteligencia Artificial',
  desc: 'Descubrí oportunidades para usar la IA y generar ingresos.',
  value: '$12.000 ARS'
}, {
  title: '50 Herramientas de Inteligencia Artificial que Debés Conocer',
  desc: 'Un directorio práctico de herramientas para crear contenido con IA.',
  value: '$8.900 ARS'
}];
export function BonusesSection() {
  return <section className="bg-gradient-to-br from-[#1a0533] via-[#2d1052] to-[#3b1466] py-24 px-4 relative" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-5xl md:text-6xl font-black text-[#FFD700] mb-6 drop-shadow-lg" data-id="element-4">
            🎁 BONOS EXCLUSIVOS
          </h2>
          <p className="text-2xl text-white font-bold bg-black/30 inline-block px-8 py-4 rounded-full border border-[#a855f7]/50" data-id="element-5">
            Si accedés hoy, también vas a recibir 3 bonos especiales.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="space-y-8" data-id="element-6">
          {BONUSES.map((bono, i) => <div key={i} className="bg-black/40 border-2 border-[#a855f7] rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 relative overflow-hidden" data-id="element-7">
              <div className="absolute top-0 right-0 bg-red-600 text-white font-bold py-1 px-10 rotate-45 translate-x-8 translate-y-4 shadow-lg" data-id="element-8">
                GRATIS
              </div>

              <div className="w-24 h-24 flex-shrink-0 bg-gradient-to-br from-[#FFD700] to-yellow-600 rounded-2xl flex items-center justify-center shadow-[0_0_20px_rgba(255,215,0,0.3)]" data-id="element-9">
                <span className="text-4xl" data-id="element-10">🎁</span>
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-11">
                <h3 className="text-2xl font-bold text-[#FFD700] mb-2" data-id="element-12">
                  BONO {i + 1}
                </h3>
                <h4 className="text-3xl font-black text-white mb-4" data-id="element-13">
                  {bono.title}
                </h4>
                <p className="text-xl text-[#c4b5d4] mb-6" data-id="element-14">{bono.desc}</p>
                <div className="inline-block bg-white/10 px-6 py-2 rounded-lg" data-id="element-15">
                  <span className="text-lg text-white/50 line-through mr-3" data-id="element-16">
                    💰 Valor: {bono.value}
                  </span>
                  <span className="text-xl font-bold text-green-400" data-id="element-17">
                    🎉 GRATIS POR LANZAMIENTO
                  </span>
                </div>
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}